import { createGlobalStyle } from "styled-components";
import { portfolio } from "./components/Themes";

const GlobalStyle = createGlobalStyle`

*,*::before,*::after{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html{
    scroll-behavior: smooth;
}

body{
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    background-color: ${portfolio.bg};
    color: ${portfolio.text};
    font-family: ${portfolio.body};
    font-size: 16px;
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
}

h1,h2,h3,h4,h5,h6{
    font-family: ${portfolio.display};
    font-weight: 600;
    line-height: 1.05;
    letter-spacing: -0.02em;
}

a{
    color: inherit;
    text-decoration: none;
}

::selection{
    background: ${portfolio.accent};
    color: #08110d;
}

/* Slim, on-brand scrollbar */
::-webkit-scrollbar{
    width: 10px;
}
::-webkit-scrollbar-track{
    background: ${portfolio.bg};
}
::-webkit-scrollbar-thumb{
    background: ${portfolio.surfaceHi};
    border-radius: 10px;
    border: 2px solid ${portfolio.bg};
}
::-webkit-scrollbar-thumb:hover{
    background: rgba(${portfolio.accentRgba}, 0.5);
}

/* Subtle film grain over the whole page to kill digital flatness */
body::after{
    content: "";
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 9;
    opacity: 0.035;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
}

:focus-visible{
    outline: 2px solid ${portfolio.accent};
    outline-offset: 3px;
    border-radius: 2px;
}

@media (prefers-reduced-motion: reduce){
    html{ scroll-behavior: auto; }
    *,*::before,*::after{
        animation-duration: 0.01ms !important;
        transition-duration: 0.01ms !important;
    }
}
`;

export default GlobalStyle;
